import React, { useState, useEffect, useContext, useRef } from 'react'
import styled from 'styled-components'
import {
  getTree,
  getTreeV2,
  getTable,
  getResultCompany,
  postData,
  updateData,
  getResultCompanyV2,
} from 'api/Admin/support'
import { getCookie } from 'helper/cookie'
import TreeSupport from '../Tree/Company/TreeSupport'
import { PlusOutlined, RedoOutlined, SearchOutlined } from '@ant-design/icons'
import iconInitialState from '../../../icons/createproject/supportneed.svg'
import DeleteProjectgroup from 'common/Management/delete'
import { set, toUpper } from 'lodash'
import { Form, Button, Col, Row, Input, Select, Space, Table, Modal } from 'antd'
import { TreeSelect } from 'antd'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import lang from 'lang/en'
import FilterSearchTree from './FilterSearchTree'
const SupportContainer = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const initialState = {
  data: [],
  pagination: {
    pageSize: 10, // จำนวนข้อมูลในหน้านั้น
    total: 0, // ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: true, // เปลี่ยนจาก 1 เป็น true เพื่อให้ถูกต้องตามประเภทข้อมูล
    showSizeChanger: false, // ไม่ให้ผู้ใช้เปลี่ยนขนาดหน้า
    showTotal: (total, range) => showToalPagination(total, range), // เปิดใช้งาน showTotal
  },
}
let fastcompanyID = 0
let text_title_drawer = ''
let eventdrawer = false
let case_api_call = ''
let item_Id = 0
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}
const Support = () => {
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [dataTree, setDataTree] = useState(initialState.data)
  const prevFilteredSupportTypes = useRef([])
  const [data, setData] = useState(initialState.data)
  const [dataTable, setDataTable] = useState(initialState.data)
  const [transfromData, setTransfromdata] = useState(initialState.data)
  const [resultscompany, setResultscompany] = useState(initialState.data)
  const [pagination, setPagination] = useState(initialState.pagination)
  const [firstate, setFirststate] = useState(true)
  const [datagodelete, setDatagodelete] = useState(initialState.data)
  const [drawer, setDrawer] = useState(false)
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [animation, setAnimation] = useState(false)
  const [errormessage, setErrormessage] = useState(true)
  const [form1] = Form.useForm()

  const [selectedItems, setSelectedItems] = useState([])

  const [openTreeSelect, setOpenTreeSelect] = useState(false)
  const [filteredSupportTypes, setFilteredSupportTypes] = useState([])
  const [filterDataSupport, setFilterDataSupport] = useState([])
  const [filteredTreeSupport, setFilteredTreeSupport] = useState([])
  const [firstTimeFilter, setFirstTimeFilter] = useState(true)
  const [dataCache, setDataCache] = useState({}) // เพิ่ม cache เพื่อเก็บข้อมูลที่เคยดึงมาแล้ว

  const fetchData = async (companyId) => {
    setAnimation(false)

    // ถ้ามีข้อมูลใน cache แล้ว ให้ใช้ข้อมูลจาก cache
    if (dataCache[companyId]) {
      setDataTable(dataCache[companyId])

      // ตั้งค่า pagination
      if (dataCache[companyId].length <= 10) {
        setPagination(false)
      } else {
        const paginationConfig = {
          ...initialState.pagination,
          total: dataCache[companyId].length,
          current: 1,
        }
        setPagination(paginationConfig)
      }

      setAnimation(true)
      return
    }

    try {
      const response = await getTable({
        token: token,
        company_id: companyId,
      })

      if (response.status === 200) {
        // เก็บข้อมูลลง cache
        setDataCache((prev) => ({
          ...prev,
          [companyId]: response.data,
        }))

        setDataTable(response.data)
        setFirststate(false)

        // ตั้งค่า pagination
        if (response.data.length <= 10) {
          setPagination(false)
        } else {
          const paginationConfig = {
            ...initialState.pagination,
            total: response.data.length,
            current: 1,
          }
          setPagination(paginationConfig)
        }
      } else {
        setDataTable([])
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      // setDataTable([])
    } finally {
      setAnimation(true)
    }
  }

  const fetchAllSupportData = async () => {
    setAnimation(false)

    try {
      if (dataTree && dataTree.length > 0) {
        const fetchPromises = dataTree.map((company) =>
          getTable({
            token: token,
            company_id: company.id,
          })
            .then((response) => {
              if (response.status === 200) {
                return response.data || []
              }
              return []
            })
            .catch((error) => {
              console.error(`Error fetching data for company ${company.id}:`, error)
              return []
            }),
        )

        const results = await Promise.all(fetchPromises)
        const allData = [].concat(...results)

        // เก็บข้อมูลใน cache เพื่อใช้ในครั้งถัดไป
        dataTree.forEach((company, index) => {
          setDataCache((prev) => ({
            ...prev,
            [company.id]: results[index] || [],
          }))
        })

        setFilterDataSupport(allData)

        if (allData.length <= 10) {
          setPagination(false)
        } else {
          const paginationConfig = {
            ...initialState.pagination,
            total: allData.length,
            current: 1,
          }
          setPagination(paginationConfig)
        }
      }
    } catch (error) {
      console.error('Error fetching all support data:', error)
      setFilterDataSupport([])
    } finally {
      setAnimation(true)
    }
  }

  useEffect(() => {
    if (filteredSupportTypes.length > 0) {
      if (filteredSupportTypes.includes(0)) {
        // กรณีเลือก All - แสดงข้อมูลทั้งหมด
        setFilteredTreeSupport(dataTree)
        fetchAllSupportData()
      } else {
        // กรณีไม่ได้เลือก All - กรองข้อมูลตามปกติ
        const filteredTree =
          dataTree && dataTree.length > 0
            ? dataTree.filter((item) => filteredSupportTypes.includes(item.id))
            : []
        setFilteredTreeSupport(filteredTree)

        const dataFilteredSupport =
          dataTable && dataTable.length > 0
            ? dataTable.filter((item) => filteredSupportTypes.includes(item.company_id))
            : []
        setFilterDataSupport(dataFilteredSupport)

        if (dataFilteredSupport.length <= 10) {
          setPagination(false)
        } else {
          const paginationConfig = {
            ...initialState.pagination,
            total: dataFilteredSupport.length,
            current: 1,
          }
          setPagination(paginationConfig)
        }

        if (filteredTree.length > 0) {
          fastcompanyID = filteredTree[0].id
          fetchData(filteredTree[0].id)
        }
      }
    } else {
      setFilteredTreeSupport(dataTree)
      // ไม่ต้องเรียก fetchData เพื่อไม่ให้ข้อมูลเปลี่ยน เมื่อ unselect All
    }
  }, [filteredSupportTypes])

  useEffect(() => {
    prevFilteredSupportTypes.current = []
  }, [])

  useEffect(() => {
    if (filterDataSupport.length > 0 && firstTimeFilter) {
      fastcompanyID = filterDataSupport[0].id
      setFirstTimeFilter(false)
    }
  }, [filterDataSupport, firstTimeFilter])

  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  // const handleTreeSelect = (action) => {
  //   if (action === 'cancel') {
  //     setOpenTreeSelect(false)
  //   } else if (action === 'confirm') {
  //     setOpenTreeSelect(false)
  //   }
  // }

  useEffect(() => {
    if (openTreeSelect && selectedItems.includes(0)) {
      const allItemIds = dataTable.map((item) => item.id)
      const allSelected = allItemIds.every((id) => selectedItems.includes(id))

      if (!allSelected) {
        setSelectedItems([0, ...allItemIds])
      }
    }
  }, [openTreeSelect, selectedItems, dataTable])

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 15) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  const [wordERR, setWordERR] = useState('')
  const Option = Select.Option
  const fetchDataTree = async () => {
    await getTreeV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataTree([])

          return true
        }
        if (status === 200) {
          if (firstate === true) {
            fastcompanyID = data.result[0].id
            // fetchDataTable()
          }

          setDataTree(data.result)
        } else {
          setDataTree([])
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const handleTreeUpdate = (treeId) => {
    if (treeId) {
      fastcompanyID = treeId
      fetchData(treeId)
    }
  }

  const fetchDataTable = async () => {
    setAnimation(false) // แสดง loading state

    await getTable({
      token: token,
      company_id: fastcompanyID,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataTable([])
          setAnimation(true)
          return true
        }
        if (status === 200) {
          setDataTable(data)
          setFirststate(false)

          // อัพเดท pagination ตามจำนวนข้อมูลที่ได้
          if (data.length <= 10) {
            setPagination(false)
          } else {
            const paginationConfig = {
              ...initialState.pagination,
              total: data.length,
              current: 1, // รีเซ็ตกลับไปหน้าแรกเมื่อมีการโหลดข้อมูลใหม่
            }
            setPagination(paginationConfig)
          }

          setAnimation(true)
        } else {
          setDataTable([])
          setAnimation(true)
          return true
        }
      })
      .catch((error) => {
        setDataTable([])
        console.error('Error fetching data table:', error)
        setAnimation(true)
      })
  }

  const fetchResultsCompany = async () => {
    await getResultCompanyV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setData([])
          setResultscompany([])

          return true
        }
        if (status === 200) {
          setResultscompany(data.result)
        } else {
          setData([])
          setResultscompany([])
          return true
        }
      })
      .catch((error) => {
        setData([])
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      fetchDataTree()
      fetchResultsCompany()
    }
  }, [token])

  useEffect(() => {
    if (token && transfromData.id) {
      fastcompanyID = transfromData.id
      fetchData(transfromData.id)
    }
  }, [token, transfromData])

  function onChange(pagination2, filters, sorter, extra) {
    // ตรวจสอบว่า pagination ไม่ใช่ false ก่อนอัพเดท
    if (pagination !== false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }

  const getPaginatedData = (data) => {
    if (!pagination || pagination === false) {
      return data // ถ้าไม่มี pagination ให้แสดงข้อมูลทั้งหมด
    }

    // คำนวณข้อมูลที่จะแสดงตามหน้าปัจจุบัน
    const { current, pageSize } = pagination
    const startIndex = (current - 1) * pageSize
    const endIndex = startIndex + pageSize

    return data.slice(startIndex, endIndex)
  }
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }
  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="BTN_Next"
            onClick={() => renderDrawer([], 'add')}
            hidden={permissionPage.create ? false : true}
          >
            <PlusOutlined className="Icon-color" />
            {word['Add_Support_Category']}
          </Button>
          <Button
            style={{ marginLeft: 8 }}
            type="primary"
            className="btn_Secondary2"
            onClick={() => window.location.reload()}
          >
            <RedoOutlined className="Icon-color" />
            {word['Reset']}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',

    render: (text) => (searchedColumn === dataIndex ? text : text),
  })
  const dataSourceTable = () => {
    let displayData

    if (filteredSupportTypes.length > 0) {
      if (filteredSupportTypes.includes(0)) {
        displayData = filterDataSupport
      } else {
        displayData = dataTable
      }
    } else {
      displayData = dataTable
    }

    // แปลงข้อมูลให้อยู่ในรูปแบบที่ต้องการแสดง
    return displayData.map((item) => ({
      key: item.id, // เพิ่ม key เพื่อให้ React รู้ว่าแต่ละแถวคืออะไร
      company_code: item.company_code,
      group_code: item.code,
      local_name: item.title,
      english_name: item.title_en,
      data: item,
    }))
  }

  const columns_group = [
    {
      title: <h5>{word['Business']}</h5>,
      dataIndex: 'company_code',
    },
    {
      title: <h5>{word['Support_code']}</h5>,
      dataIndex: 'group_code',
      sorter: (a, b) => a.group_code.localeCompare(b.group_code),
      ...getColumnSearchProps('group_code'),
    },
    {
      title: <h5>{word['Local_name']}</h5>,
      dataIndex: 'local_name',
      sorter: (a, b) => a.local_name.localeCompare(b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local_name'),
    },
    {
      title: <h5>{word['English_name']}</h5>,
      dataIndex: 'english_name',
      sorter: (a, b) => a.english_name.localeCompare(b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english_name'),
    },
  ]

  const renderDrawer = (dataIncome, fade) => {
    setDrawer(true)
    setErrormessage(true)
    case_api_call = fade
    if (fade === 'add') {
      eventdrawer = true
      text_title_drawer = 'Add Support Category'
      form1.setFieldsValue({
        form_company_code: fastcompanyID,
        form_support_category_code: null,
        form_local_support_category_name: null,
        form_english_support_category_name: null,
      })
    } else if (fade === 'edit') {
      eventdrawer = false
      text_title_drawer = 'Edit Support Category'
      item_Id = dataIncome.data.id
      setDatagodelete(dataIncome.data)
      permissionPage.update ? setDisablePage(false) : setDisablePage(true)
      form1.setFieldsValue({
        form_company_code: dataIncome.data.company_id,
        form_support_category_code: dataIncome.data.code,
        form_local_support_category_name: dataIncome.data.title,
        form_english_support_category_name: dataIncome.data.title_en,
      })
    }
  }

  const onFinish = (value) => {
    if (case_api_call === 'add') {
      const newDataMaster = {
        company_id: value.form_company_code,
        code: value.form_support_category_code,
        title: value.form_local_support_category_name,
        title_en: value.form_english_support_category_name,
      }
      try {
        postData({
          params: newDataMaster,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setDrawer(false)

            // ล้าง cache ของ company นี้ เพื่อบังคับให้โหลดข้อมูลใหม่
            setDataCache((prev) => {
              const newCache = { ...prev }
              delete newCache[value.form_company_code]
              return newCache
            })

            // ตรวจสอบว่ามีการเลือก All หรือไม่
            if (filteredSupportTypes.includes(0)) {
              // ล้าง filterDataSupport เพื่อบังคับให้โหลดข้อมูลใหม่
              setFilterDataSupport([])
              fetchAllSupportData()
            } else {
              fetchData(fastcompanyID)
            }

            setErrormessage(true)
          } else {
            if (res.data.errorCode === '2008') {
              setWordERR(word['err_supportcat_code'])
            } else {
              setWordERR('error')
            }
            setErrormessage(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (case_api_call === 'edit') {
      const newDataMaster = {
        id: item_Id,
        company_id: value.form_company_code,
        code: value.form_support_category_code,
        title: value.form_local_support_category_name,
        title_en: value.form_english_support_category_name,
      }
      try {
        updateData({
          params: newDataMaster,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setDrawer(false)

            // ล้าง cache ของ company นี้ เพื่อบังคับให้โหลดข้อมูลใหม่
            setDataCache((prev) => {
              const newCache = { ...prev }
              delete newCache[value.form_company_code]
              return newCache
            })

            // ตรวจสอบว่ามีการเลือก All หรือไม่
            if (filteredSupportTypes.includes(0)) {
              // ล้าง filterDataSupport เพื่อบังคับให้โหลดข้อมูลใหม่
              setFilterDataSupport([])
              fetchAllSupportData()
            } else {
              fetchData(fastcompanyID)
            }

            setErrormessage(true)
          } else {
            if (res.data.errorCode === '2018') {
              setWordERR(word['err_supportcat_itemused'])
            } else if (res.data.errorCode === '2008') {
              setWordERR(word['err_supportcat_code'])
            } else {
              setWordERR('error')
            }
            setErrormessage(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onFail = () => { }
  const onClickDelete = () => {
    setVisibleDelete(true)
  }
  const RenderStateTable = () => {
    if (dataTable.length > 0) {
      return (
        <div className={animation ? 'animation-container' : 'active-animation-container'}>
          <div className="layout-button-add-normal-state">
            <TextTitleBold> List Support </TextTitleBold>
            <div style={{ display: 'flex', alignItems: 'center' }}>

              <Button
                type="primary"
                className="BTN_Next"
                onClick={() => renderDrawer([], 'add')}
                hidden={permissionPage.create ? false : true}
              >
                <PlusOutlined className="Icon-color" />
                {word['Add_Support_Category']}
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                type="primary"
                className="btn_Secondary2"
                onClick={() => window.location.reload()}
              >
                <RedoOutlined className="Icon-color" />
                {word['Reset']}
              </Button>
            </div>
          </div>
          <Table
            onRow={(record) => {
              return {
                onClick: () => renderDrawer(record, 'edit'), // click row
              }
            }}
            columns={columns_group}
            dataSource={dataSourceTable()}
            onChange={onChange}
            showSorterTooltip={false}
            pagination={pagination}
            loading={!animation}
            rowKey={(record) => record.data.id}
          />
        </div>
      )
    } else {
      return (
        <div
          className={
            animation ? 'initialstate-container' : 'active-initialstate-container'
          }
        >
          <img className="initialstate-icon" src={iconInitialState}></img>
          <h2>{word['Please_add_support_category']}</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            type="primary"
            className="btn_Secondary2"
            onClick={() => renderDrawer([], 'add')}
          >
            <PlusOutlined className="Icon-color" />
            {word['Add_Support_Category']}
          </Button>
        </div>
      )
    }
  }

  return (
    <SupportContainer>
      <div className="layoutmanagement-git-master">
        <div className="layout-left">
          <div style={{ marginTop: 16, marginBottom: 16, marginLeft: 16, marginRight: 16 }}>
            <FilterSearchTree
              dataItems={resultscompany}
              selectedItems={filteredSupportTypes}
              setSelectedItems={setFilteredSupportTypes}
              placeholderText="Select Support Type"
              itemTypeName="Business"
              treeId="support-type"
              excludeAllID={false}
            />
          </div>
          <TreeSupport
            dataTree={filteredTreeSupport.length > 0 ? filteredTreeSupport : dataTree}
            setTransfromdata={setTransfromdata}
            onTreeUpdate={handleTreeUpdate}
          />
        </div>
        <div className="layout-right">{RenderStateTable()}</div>
      </div>
      <Modal
        maskClosable={false}
        destroyOnClose
        title={<TextTitleBold>{text_title_drawer}</TextTitleBold>}
        onCancel={() => setDrawer(false)}
        visible={drawer}
        width={'634px'}
        className="fix-modal"
        centered
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button
              hidden={permissionPage.delete ? eventdrawer : true}
              className="BTN_Delete_CPF_RED"
              style={{ marginRight: 8 }}
              onClick={() => onClickDelete()}
            >
              {word['Delete']}
            </Button>
            <Button
              hidden={permissionPage.update ? false : true}
              className="BTN_Next"
              onClick={form1.submit}
              type="primary"
            >
              {word['Save']}
            </Button>
          </div>
        }
      >
        <Form form={form1} layout="vertical" onFinish={onFinish} onFinishFailed={onFail}>
          <fieldset disabled={disablePage} className="disable-page">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="form_company_code"
                  label={<h4>{word['Business_Code']}</h4>}
                  rules={[{ required: true, message: 'please select business. ' }]}
                  className="disable-page"
                >
                  <Select
                    showSearch
                    id="select"
                    size="large"
                    disabled={disablePage}
                    placeholder="Business Code"
                    allowClear
                    optionFilterProp="children"
                  >
                    {resultscompany.map((item) => (
                      <Option key={item.id} value={item.id} data={item}>
                        {item.code} {item.name_en}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="form_support_category_code"
                  label={<h4>{word['Support_Category_Code']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter support category code.',
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Support Category Code"
                    onChange={(e) =>
                      form1.setFieldsValue({
                        form_support_category_code: e.target.value.replace(/\s/g, ''),
                      })
                    }
                    onKeyUp={(e) =>
                      form1.setFieldsValue({
                        form_support_category_code: toUpper(e.target.value),
                      })
                    }
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="form_local_support_category_name"
                  label={<h4>{word['Local_Support_Category_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local support category name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Local Support Category Name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="form_english_support_category_name"
                  label={<h4>{word['English_Support_Category_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english support category name.',
                    },
                  ]}
                >
                  <Input placeholder="English Support Category Name" size="large" />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>
        <DeleteProjectgroup
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state="support_category"
          data={datagodelete}
          renderData={() => fetchData(fastcompanyID)} // เปลี่ยนจาก fetchDataTable เป็น () => fetchData(fastcompanyID)
          setVisibleDrawer={setDrawer}
        />
      </Modal>
    </SupportContainer>
  )
}
export default Support
